import * as React from 'react'
import styled from 'styled-components'
import { media } from '../utils/media'

interface IProps {
  labels: string[],
  start?: number
}

export const ScaleExplanationSmall = ({ labels, start=0 }: IProps) => (
  <ScaleItems>
    {labels.map((label, i) =>
      <ScaleItemContainer key={label}>
        <ScaleItem>{start + i + 1}</ScaleItem>
        <ScaleLabel>{label}</ScaleLabel>
      </ScaleItemContainer>,
    )}
  </ScaleItems>
)

const ScaleItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 8px;
`

const ScaleItemContainer = styled.div`
  flex: 0 1 auto;
  font-family: "SF Pro Display";
  font-size: 14px;
  color: white;
  white-space: pre;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;

  ${media.tablet`
    flex: 0 0 80px;
    font-size: 16px;
    margin-right: 20px;
  `}
`

const ScaleItem = styled.div`
  border-radius: 100%;
  width: 35px;
  height: 35px;
  line-height: 28px;
  border: 1px solid #FA8D2D;
  background: white;
  color: #172129;
  padding: 0;
  
  font-family: Nunito;
  font-size: 15px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;

  ${media.tablet`
    width: 38px;
    height: 38px;
    line-height: 34px;
    font-size: 20px;
    `}

`

const ScaleLabel = styled.div`
  text-align: center;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/atoms/ScaleExplanationSmall.tsx